<template>
  <div class="container-fluid login-view">
    <div class="container">
      <div class="vh-100 row align-items-center justify-content-center">
        <div class="col-xs-12 col-md-6">
          <div class="card">
            <div class="card-body p-5">
              <div class="row">
                <div class="col-12">
                  <div class="row align-items-center justify-content-center mb-5">
                    <img
                      class="mw-100"
                      src="@/assets/CL-light.png"
                      height="40px"
                    />
                  </div>
                  <h5 class="card-title">Willkommen zurück!</h5>
                  <p class="card-text mt-4">Bitte loggen Sie sich ein, um fortzufahren.</p>
                  <form @submit.prevent="login">
                    <div class="form-group mb-0">
                      <label for="email">E-Mail</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="email"
                        placeholder="E-Mail"
                        name="email"
                        required
                      />
                      <div class="feedback-placeholder"></div>
                    </div>

                    <label for="email">Passwort</label>
                    <b-input-group>
                      <b-form-input
                        placeholder="Passwort"
                        v-model="password"
                        :type="passwordFieldType"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button @click="switchVisibility">
                          <b-icon :icon="passwordIcon"></b-icon>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>

                    <button
                      type="submit"
                      class="btn btn-primary btn-block mt-4"
                    >Login</button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',

  data () {
    return {
      email: '',
      password: '',
      passwordFieldType: 'password',
      passwordIcon: 'eye-slash-fill'
    };
  },

  methods: {
    switchVisibility () {
      this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
      this.passwordIcon = this.passwordFieldType === 'password' ? 'eye-slash-fill' : 'eye-fill'
    },
    async login () {
      this.loginIsRunning = true;

      await this.$store.dispatch('auth/login', {
        email: this.email.replace(/\s+$/g, ''),
        password: this.password,
      });

      this.$router.push('/');
    },
  }
}
</script>

<style scoped>
.login-view {
  background-image: linear-gradient(
      0deg,
      rgba(255, 255, 255, 0.1),
      rgba(255, 255, 255, 0.5)
    ),
    url("~@/assets/h8.jpg");
  background-size: cover;
  height: 100%;
}
</style>
